import CmsHooks from "@shared/utils/register/CmsHooks";
import Layout from "@project/components/layout/Layout";
import NotFound from "@project/components/NotFound";
import templates from "@project/templates/templates";
import theme from "@project/theme/theme";
import getDynamicComponent from "@project/utils/getDynamicComponent";
import { HOOKS } from "@shared/utils/register/definitions";
export default () => {
    CmsHooks.registerHook(HOOKS.PAGESWITCHER_404, NotFound);
    CmsHooks.registerHook(HOOKS.APP_LAYOUT, Layout);
    CmsHooks.registerHook(HOOKS.THEME, theme);
    CmsHooks.registerHook(HOOKS.TEMPLATES, templates);
    CmsHooks.registerHook(HOOKS.APP_ROUTES, []);
    CmsHooks.registerHook(HOOKS.TEMPLATEPROPS_UTILS_GETDYNAMICCOMPONENT, getDynamicComponent);
    CmsHooks.registerHook(HOOKS.TRACKING_ACTIVE, true);
    CmsHooks.registerHook(HOOKS.IS_CONSENT_CONFIG, true);
};
